import { render, staticRenderFns } from "./files-item.vue?vue&type=template&id=5b5ad992&scoped=true&lang=pug&"
import script from "./files-item.vue?vue&type=script&lang=js&"
export * from "./files-item.vue?vue&type=script&lang=js&"
import style0 from "./files-item.vue?vue&type=style&index=0&id=5b5ad992&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ad992",
  null
  
)

export default component.exports